<template>
    <div class="menu">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'BMenu'
}
</script>
